const KEY = "factscan:auth_intent";
const TTL_MS = 5 * 60 * 1000;

type Intent = "signup" | "login";

/**
 * Short-lived hint set by the email signup path so the centralized
 * SIGNED_IN handler can classify the resulting session as signup vs login
 * without relying solely on the created_at heuristic.
 */
export function setAuthIntent(intent: Intent) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ intent, expiresAt: Date.now() + TTL_MS }),
    );
  } catch {
    // ignore (private mode etc.)
  }
}

export function consumeAuthIntent(): Intent | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw) as { intent?: Intent; expiresAt?: number };
    if (!parsed?.intent || !parsed?.expiresAt) return null;
    if (Date.now() > parsed.expiresAt) return null;
    if (parsed.intent !== "signup" && parsed.intent !== "login") return null;
    return parsed.intent;
  } catch {
    return null;
  }
}